if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      const endDate = this.getAttribute('data-end');
      if (!endDate) {
        this.style.display = "none"; // Hide the element
        return;
      }
      
      this.updateCountdown(endDate);
      setInterval(() => {
        this.updateCountdown(endDate);
      }, 1000);
    }

    formatNumberWithZero(number) {
      return number.toString().padStart(2, '0');
    }

    updateCountdown(endDate) {
      var end = new Date(endDate).getTime();
      var now = new Date().getTime();
      var distance = end - now;
      if (distance < 0) {
        this.innerHTML = '<div class="countdown_block"><span class="timer_number">00</span><span class="timer_label">d</span></div>';
        this.innerHTML += '<div class="countdown_block"><span class="timer_number">00</span><span class="timer_label">h</span></div>';
        this.innerHTML += '<div class="countdown_block"><span class="timer_number">00</span><span class="timer_label">m</span></div>';
        this.innerHTML += '<div class="countdown_block"><span class="timer_number">00</span><span class="timer_label">s</span></div>';
        return;
      }
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
      this.innerHTML = '<div class="countdown_block"><span class="timer_number">'+this.formatNumberWithZero(days)+'</span><span class="timer_label">d</span></div>';
      this.innerHTML += '<div class="countdown_block"><span class="timer_number">'+this.formatNumberWithZero(hours)+'</span><span class="timer_label">h</span></div>';
      this.innerHTML += '<div class="countdown_block"><span class="timer_number">'+this.formatNumberWithZero(minutes)+'</span><span class="timer_label">m</span></div>';
      this.innerHTML += '<div class="countdown_block"><span class="timer_number">'+this.formatNumberWithZero(seconds)+'</span><span class="timer_label">s</span></div>';
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}


//Success Popup
const themeSuccessModalElements = document.querySelectorAll('.success_modal');
themeSuccessModalElements.forEach(function(element) {
  var themeSuccessModal = new bootstrap.Modal(element, {
    keyboard: false
  });
  themeSuccessModal.show();
});


//Height Calculator
function calculateAndSetHeight() {
  const divElements = document.querySelectorAll('[height-calculate]'); 
  divElements.forEach(divElement => {
    const height = divElement.offsetHeight; 
    const parentElement = divElement.parentElement;
    parentElement.style.setProperty('--element-height', height + 'px'); 
  });
}

//Collection Grid Swatcher
function CollectionGridSwitcher(){
  const buttons = document.querySelectorAll('.short_head button');
  buttons.forEach(function(button) {
    button.addEventListener('click', function() {
      const grid = document.querySelector('.collection_product_grid');
      
      if (this.id === 'grid_view') {
        grid.classList.toggle('grid_2_column_enable');
        grid.classList.remove('gird_list_view_enable');
      } 
      if (this.id === 'grid_list') {
        grid.classList.toggle('gird_list_view_enable');
        grid.classList.remove('grid_2_column_enable');
      }
    });
  });
}


const header = document.querySelector('.section_header');
const scrollUp = 'sticky-up';
const scrollDown = 'sticky-down';
let lastScroll = 0;
window.addEventListener('scroll', () => {
  const currentScroll = window.pageYOffset;

  if (currentScroll <= 0) {
    header.classList.remove(scrollUp);
    return;
  }

  if (currentScroll > lastScroll && !header.classList.contains(scrollDown)) {
    // down
    header.classList.remove(scrollUp);
    header.classList.add(scrollDown);
  } else if (currentScroll < lastScroll && header.classList.contains(scrollDown)) {
    // up
    header.classList.remove(scrollDown);
    header.classList.add(scrollUp);
  }

  lastScroll = currentScroll;
});



//Remove Quick Cart
const outerCart = document.querySelector('.outer_quick_cart');
outerCart?.addEventListener('click', () => {
  document.body.classList.remove('kt-cart-open');
});


//Collection Filter Toggle
const filterToggle = document.querySelector('#filter_toggle');
function toggleFilter() {
  const templates = document.querySelectorAll('.main_collection_template, .search_page_template');
  templates.forEach(template => template.classList.toggle('collection_filter_enable'));
}
if (filterToggle) {
  filterToggle.addEventListener('click', toggleFilter);
}

/*
 * Shopify Common JS
 *
 */

if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
}; 
  
class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    button?.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });

    const a = this.querySelector('a:not(.btn-wishlist)');
    a?.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector(this.getAttribute('data-modal'))?.show(a);
    });
  }

}
customElements.define('modal-opener', ModalOpener);  


if (!customElements.get('soldout-timer')) {
  class SoldOutTimerElement extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.updateDataAttributes();
      setInterval(this.updateDataAttributes.bind(this), 60 * 60 * 1000);
    }

    generateRandomValues(items, hours) {
      var randomItemIndex = Math.floor(Math.random() * items.length);
      var randomHourIndex = Math.floor(Math.random() * hours.length);

      var randomItem = items[randomItemIndex];
      var randomHour = hours[randomHourIndex];

      return { item: randomItem, hour: randomHour };
    }

    updateDataAttributes() {
      var items = this.getAttribute('data-items').split(',').map(item => item.trim());
      var hours = this.getAttribute('data-hours').split(',').map(hour => hour.trim());

      var randomValues = this.generateRandomValues(items, hours);

      this.setAttribute('data-item', randomValues.item);
      this.setAttribute('data-hours', randomValues.hour);

      var soldOutNumber = this.querySelector('[data-sold-out-number]');
      soldOutNumber.textContent = randomValues.item;

      var soldOutHours = this.querySelector('[data-sold-out-hours]');
      soldOutHours.textContent = randomValues.hour;

      this.style.display = 'block';
    }
  }
  customElements.define('soldout-timer', SoldOutTimerElement);
}

if (!customElements.get('stock-sountdown')) {
  class Stockcountdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const progressBarAttr = this.getAttribute('data-progressbar');
      const numbers = progressBarAttr.split(',').map(Number);
      const getRandomNumber = () => {
        return numbers[Math.floor(Math.random() * numbers.length)];
      }

      const updateProgressBarAndCountdown = () => {
        const randomValue = getRandomNumber();
        const progressBarValue = (randomValue / 100) * 100;
        this.querySelector('#progress-bar').style.width = progressBarValue + '%';
        this.querySelector('#progessbar_soldout_item').textContent = randomValue;
      }

      const startCountdown = () => {
        const interval = setInterval(() => {
          updateProgressBarAndCountdown();
        }, 90000);
        updateProgressBarAndCountdown();
      }
      startCountdown();
    }
  }
  customElements.define('stock-sountdown', Stockcountdown); 
}

//Accordion
if (!customElements.get('kt-accordion')) {
  class ktAccordion extends HTMLElement {
    constructor() {
      super();
      const accordionTitles = this.querySelectorAll(".kt_accordion_title");
      const isActive = this.getAttribute("data-active") === "true";
      // code enable when first item will show by default
      if (accordionTitles.length > 0 && isActive) {
        accordionTitles[0].classList.add("is-open");
        const accordionContent = accordionTitles[0].nextElementSibling;
        accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
      }

      accordionTitles.forEach((accordion) => {
        accordion.onclick = function () {
          this.classList.toggle("is-open");
          let accordion_content = this.nextElementSibling;

          if (accordion_content.style.maxHeight) {
            accordion_content.style.maxHeight = null;
          } else {
            accordion_content.style.maxHeight = accordion_content.scrollHeight + "px";
          }
        };
      });
    }
  }
  customElements.define('kt-accordion', ktAccordion);
}

class VariantSelectElement extends HTMLElement {
  constructor() {
    super();
    this.initialized = false; // Track initialization status
  }

  connectedCallback() {
    if (!this.initialized) {
      const variantSelect = this.querySelector('.variant-select');
      const dropdownButton = this.querySelector('.dropdown-select-button');
      const cardDropdownArea = this.querySelector('.card_dropdown_area');

      if (!variantSelect || !dropdownButton || !cardDropdownArea) {
        return;
      }
      const variantListItems = variantSelect.querySelectorAll('li');

      const hideDropdown = () => {
        variantSelect.classList.remove('show');
        cardDropdownArea.classList.remove('active');
      };

      dropdownButton.addEventListener('click', () => {
        variantSelect.classList.toggle('show');
        cardDropdownArea.classList.toggle('active');
      });

      // Function to select the first variant by default and set the initial dropdown text
      const selectFirstVariant = () => {
        const firstVariant = variantListItems[0];
        if (firstVariant) {
          firstVariant.click(); 
          dropdownButton.textContent = firstVariant.textContent;
        }
      };

      variantListItems.forEach((li) => {
        li.addEventListener('click', () => {
          const selectedOption = li;
          const variantImage = selectedOption.dataset.variantImageUrl;
          const variantImageAlt = selectedOption.dataset.variantImageAlt;
          const variantId = selectedOption.dataset.variantId;
          const variantValue = selectedOption.textContent;

          const variantregular_price = selectedOption.dataset.variantRegularPrice;
          const variantcompare_price = selectedOption.dataset.variantComparePrice;

          const productCard = variantSelect.closest('.product_card, .outer_card');
          const productImage = productCard.querySelector('.card_feature_image img');
          const variantIdInput = productCard.querySelector('.variant-id-input');

          const newPriceElement = productCard.querySelector('.prodcut-price .new-price');
          const oldPriceElement = productCard.querySelector('.prodcut-price .old-price');

          variantListItems.forEach((item) => {
            item.classList.remove('active');
          });
          selectedOption.classList.add('active');

          if (variantImage) {
            productImage.setAttribute('src', variantImage);
            productImage.setAttribute('srcset', variantImage);
            productImage.setAttribute('alt', variantImageAlt);
          }

          if (variantregular_price) {
            newPriceElement.textContent = variantregular_price;
          }

          if (variantcompare_price) {
            oldPriceElement.textContent = variantcompare_price;
          }

          if (variantIdInput) {
            variantIdInput.value = variantId;
          }

          dropdownButton.textContent = variantValue;
          hideDropdown();
        });
      });

      document.addEventListener('click', (event) => {
        const targetElement = event.target;

        if (!cardDropdownArea.contains(targetElement) && targetElement !== dropdownButton) {
          hideDropdown();
        }
      });
      selectFirstVariant();
      this.initialized = true; 
    }
  }
}
customElements.define('card-variant-selects', VariantSelectElement);

if (!customElements.get('card-variant-selects')) {
  const variantSelects = document.createElement('card-variant-selects');
  document.body.appendChild(variantSelects);
}


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            initButtons();
            initButtonsCompare();
          }

          if (!this.querySelectorAll('.complementary-grid') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.recommended-items')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}
customElements.define('product-recommendations', ProductRecommendations);

function mobileMenu(){
  const menuItems = document.querySelectorAll("#mobile_menu .nav-item.dropdown");
  menuItems.forEach(item => {
    const toggleButton = item.querySelector(".nav-link.dropdown-toggle");
    const submenu = item.querySelector(".submenu");

    if (toggleButton && submenu) {
      toggleButton.addEventListener("click", function(e) {
        e.preventDefault();
        menuItems.forEach(otherItem => {
          if (otherItem !== item) {
            const otherSubmenu = otherItem.querySelector(".submenu");
            if (otherSubmenu) {
              otherSubmenu.classList.remove("active");
            }
          }
        });
        submenu.classList.toggle("active");
      });
    }
  });
}

function headerCollectionDropdown(){
  const toggleButtons = document.querySelectorAll('.btn_toggle');
  toggleButtons.forEach(button => {
      button.addEventListener('click', function (event) {
        event.stopPropagation();
        const headerCollection = this.closest('.header_collection');          
        if (headerCollection) {
            headerCollection.classList.toggle('active');
        }
      });
  });
}

headerCollectionDropdown();
CollectionGridSwitcher();
calculateAndSetHeight();
mobileMenu();


function getonloadscript(source, callback) {
  var script = document.createElement('script');
  var prior = document.getElementsByTagName('script')[0];
  script.async = 1;

  script.onload = script.onreadystatechange = function( _, isAbort ) {
      if(isAbort || !script.readyState || /loaded|complete/.test(script.readyState) ) {
          script.onload = script.onreadystatechange = null;
          script = undefined;

          if(!isAbort && callback) setTimeout(callback, 0);
      }
  };
  script.src = source;
  prior.parentNode.insertBefore(script, prior);
}


function setupScrollAnimation(className) {
  const animatedSections = document.querySelectorAll('.' + className);

  if (animatedSections.length === 0) {
    return;
  }

  let isScrollingDown = false;

  function checkScroll() {
    const offset = window.innerHeight - 50;

    animatedSections.forEach(animatedSection => {
      const rect = animatedSection.getBoundingClientRect();
      const isSectionVisible = rect.top < window.innerHeight && rect.bottom >= 0;

      if (isScrollingDown && (isSectionVisible && rect.top < offset)) {
        animatedSection.classList.add('animate');
      } else {
        animatedSection.classList.remove('animate');
      }
    });
  }

  function handleScrollDirection() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    isScrollingDown = scrollTop > (isScrollingDown ? lastScrollTop : lastScrollTop + 5);
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
    checkScroll();
  }

  let lastScrollTop = 0;
  window.addEventListener('scroll', handleScrollDirection);
  window.addEventListener('load', checkScroll);
}

if (document.querySelectorAll('.animatedSection').length > 0) {
  setupScrollAnimation('animatedSection');
}


class VariantSelect extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.querySelectorAll(".option-item").forEach((option) => {
      option.addEventListener("click", this.onVariantChange.bind(this))
    });
  }

  onVariantChange(evt) {
    this.target = evt.target
    var select = this.target.closest(".variation_switcher_item")

    select?.querySelectorAll('.option-item').forEach((option) => {
      option.classList.remove('selected')
    })

    this.target.closest(".option-item").classList.add('selected')

    select.querySelector(".selected-value").innerHTML = this.target.closest(".option-item").getAttribute("data-value")
    
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updatePrice();
    this.stockUpdate();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      //this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }


  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {

      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updatePrice() {
    console.log(this.currentVariant);
    if (this.currentVariant) {
      const newPriceElement = document.querySelector(".product_singel_price .new-price");
      const oldPriceElement = document.querySelector(".product_singel_price .old-price");
      const comparePrice = this.currentVariant.compare_at_price;
  
      if (newPriceElement) {
        newPriceElement.textContent = Shopify.formatMoney(this.currentVariant.price);
      }
  
      if (oldPriceElement && comparePrice) {
        oldPriceElement.textContent = Shopify.formatMoney(this.currentVariant.compare_at_price);
      }
    }
  }

  updateMedia() {   
    if (this.currentVariant) {
      const featuredImage = document.querySelector('.products_image_slide .swiper-slide img');   
      const featureMediaUrl = this.currentVariant.featured_image;   
      if (featuredImage && featureMediaUrl ) { 
        const newImageUrl = this.currentVariant.featured_image.src;
        featuredImage.setAttribute('src', newImageUrl);
        featuredImage.setAttribute('srcset', newImageUrl);
      }
    }
  }

  stockUpdate(){
    const stockAvailabilityElement = document.querySelector('.meta_item_value.stock_avalability');
    if (stockAvailabilityElement) {
      stockAvailabilityElement.textContent = this.currentVariant.available ? window.product.inStock : window.product.soldOut;
    }
    
    const optionItems = document.querySelectorAll('.variation_switcher_item .option-item');
    // Iterate through each option-item
    // Remove the 'outofstock_product' class from all option items
    optionItems.forEach(optionItem => {
      optionItem.classList.remove('outofstock_product');
    });

    // Iterate through each option-item and add the class if needed
    optionItems.forEach(optionItem => {
      const dataValue = optionItem.getAttribute('data-value');

      // Check if the option-item matches the selected variant's options
      if (
        this.currentVariant.option1 === dataValue ||
        this.currentVariant.option2 === dataValue ||
        this.currentVariant.option3 === dataValue
      ) {
        if (!this.currentVariant.available) {
          optionItem.classList.add('outofstock_product');
        }
      }
    });

  } 

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;
        var meta_id = `meta-${this.dataset.section}`;
        var meta_destination = document.getElementById(meta_id);
        var meta_source = html.getElementById(meta_id);
        if (meta_source && meta_destination) meta_destination.innerHTML = meta_source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.product.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.product.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;
    addButton.textContent = window.product.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
    var meta_id = `meta-${this.dataset.section}`;
    var meta_destination = document.getElementById(meta_id);
    var available = meta_destination.querySelector(".availability span[data-available]");
    available.innerHTML = window.product.unavailable;
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]')?.textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelect);

class VariantRadios extends VariantSelect {
  constructor() {
    super();
  }

  updateOptions() {
    const current_fieldset = Array.from(this.querySelectorAll('.variation_switcher_item'));
    this.options = current_fieldset.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('.option-item'))?.find((radio) => radio.classList.contains('selected')).getAttribute("data-value");
    });
    var all_fieldsets = Array.from(document.querySelectorAll('.variation_switcher_item'));
    var other_fieldset = all_fieldsets.filter(x => !current_fieldset.includes(x))
    other_fieldset.map((fieldset) => {
      Array.from(fieldset.querySelectorAll('.option-item')).find((radio) => {
        if (this.options.includes(radio.getAttribute('data-value'))) {
          if (!radio.classList.contains("selected")) {
            radio.classList.add('selected')
            var event = new Event('click');
            radio.dispatchEvent(event)
          }
        } else {
          radio.classList.remove('selected')
        }
      });
    });
  }
}
customElements.define('variant-radios', VariantRadios);

if (!customElements.get('show-more-button')) {
  class ShowMoreButton extends HTMLElement {
    constructor() {
      super();
      const button = this.querySelector('button');
      button.addEventListener('click', (event) => {
        this.expandShowMore(event);
        const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item')
        if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden')) {
          nextElementToFocus.querySelector('input').focus()
        }
      });
    }
    expandShowMore(event) {
      const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
      const parentWrap = parentDisplay.querySelector('.parent-wrap');
      this.querySelectorAll('.label-text').forEach(element => element.classList.toggle('hidden'));
      parentDisplay.querySelectorAll('.show-more-item').forEach(item => item.classList.toggle('hidden'))
    }
  }
  customElements.define('show-more-button', ShowMoreButton);
}


function showLoader(overlay) {
  overlay.style.display = 'flex';
}

function hideLoader(overlay) {
  overlay.style.display = 'none';
}

function switchTab(event) {
  const targetTabId = this.dataset.tabTarget;
  const targetTab = document.querySelector(targetTabId);
  const currentTabSection = this.closest('.ktTabs');
  if (targetTab.style.display === 'block') {
    return; 
  }

  // Create and insert the loader overlay when a tab is clicked
  const loaderOverlay = document.createElement('div');
  loaderOverlay.className = 'loader-overlay';
  loaderOverlay.innerHTML = '<div class="loader"></div>';
  targetTab.appendChild(loaderOverlay);
  showLoader(loaderOverlay);

  const tabsInCurrentSection = currentTabSection.querySelectorAll('.tab-content');
  tabsInCurrentSection.forEach(tab => tab.style.display = 'none');

  // Remove 'active' class from all tab buttons within the current tab section
  const buttonsInCurrentSection = currentTabSection.querySelectorAll('.tab-btn');
  buttonsInCurrentSection.forEach(btn => btn.classList.remove('active'));

  const parentElement = this.parentElement; // Change this line based on your HTML structure
  parentElement.classList.add('active');

  targetTab.style.display = 'block';
  this.classList.add('active');
  setTimeout(() => {
    hideLoader(loaderOverlay);
    targetTab.removeChild(loaderOverlay);
  }, 1500);
}

document.querySelectorAll('.ktTabs').forEach(tabSection => {
  const tabButtons = tabSection.querySelectorAll('.tab-btn');
  const tabPanels = tabSection.querySelectorAll('.tab-content');

  tabButtons.forEach((btn, index) => {
    btn.addEventListener('click', switchTab);
    if (index === 0) {
      btn.classList.add('active');
    }
  });

  // Set the first tab panel as active on page load
  if (tabPanels.length > 0) {
    tabPanels[0].style.display = 'block';
    tabPanels[0].classList.add('active');
  }
});


function counter(selector) {
  let elements = document.querySelectorAll(selector);
  elements.forEach((element) => {
    let start = 0,
      end = parseInt(element.getAttribute("ending-number")) || 80,
      duration = parseInt(element.getAttribute("counter-animation")) || 3000,
      current = start,
      range = end - start,
      increment = end > start ? 1 : -1,
      step = Math.abs(Math.floor(duration / range)),
      timer = setInterval(() => {
        current += increment;
        element.textContent = current;
        if (current == end) {
          clearInterval(timer);
        }
      }, step);
  });
}
counter(".counter_number");